import { Component, Input, OnInit } from '@angular/core'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'


@Component({
	selector: 'atyl-form-input-daterange',
	templateUrl: './form-input-daterange.component.html',
	styleUrls: ['./form-input-daterange.component.scss']
})
export class FormInputDaterangeComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	label: string
	errorString: string

	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) { }

	ngOnInit(): void {
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}
}
